let catalog = {};
let lang = "en";

export const detectLang = () => {
  const n = (navigator.language || "en").toLowerCase();
  if (n.startsWith("es")) return "es";
  if (n.startsWith("pt")) return "pt";
  if (n.startsWith("fr")) return "fr";
  return "en";
};

export const setLang = async (l) => {
  lang = ["en", "es", "pt", "fr"].includes(l) ? l : "en";
  if (lang === "en") { catalog = {}; return; }
  try {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/i18n/${lang}?v=${Date.now()}`, { cache: "no-store" });
    if (r.ok) catalog = await r.json();
  } catch { /* fall back to English */ }
};

export const initI18n = async () => setLang(detectLang());

export const t = (key, fallback, vars) => {
  let s = catalog[key] || fallback;
  if (vars && typeof s === "string") for (const k of Object.keys(vars)) s = s.split(`{${k}}`).join(String(vars[k]));
  return s;
};
export const currentLang = () => lang;
